import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../services/AuthService";
import { toast, ToastContainer } from "react-toastify";

const ResetPassword = () => {
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const navigate = useNavigate();
    const routerLocation = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(routerLocation.search);
        const token = params.get("token");
        if (token) {
            setValue("token", token);
        }
    }, [routerLocation.search, setValue]);

    const onSubmit = async(data) => {
        try {
            const response = await AuthService.resetPassword({data});
            if (response.status === 200) {
                toast.success("Password reset successfully. You can now log in with your new password.");
                setTimeout(() => {
                    navigate("/");
                }, 2000);
            } else {
                toast.error(response?.data?.message || "Failed to reset password. Please try again.");
            }
        } catch (error) {
            console.error("Error in reset password:", error);
            toast.error(error?.response?.data?.message || error?.message || "An unknown error occurred during password reset");
        }
    }   
    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12 col-md-5 col-xl-4 my-5">
                    <h1 className="display-4 text-center mb-3">Reset Password</h1>
                    <p className="text-muted text-center mb-5">Enter your new password.</p>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label">New Password</label>
                            <input type="password" className={`form-control ${errors.password ? 'is-invalid' : ''}`} id="password" {...register("password", { required: true })} />
                            {errors.password && <div className="invalid-feedback">Password is required</div>}
                            <input type="hidden" {...register("token", { required: true })} />
                        </div>
                        <button type="submit" className="btn btn-primary w-100">Reset Password</button>
                    </form>
                </div>
            </div>
            <ToastContainer/>
        </div>
    );
}

export default ResetPassword;